import { useEffect, useRef } from 'react';
import { usePrefersReducedMotion } from '@/hooks/usePrefersReducedMotion';

const DURATION = 1200;

/**
 * 0 → to 로 세어 올린다.
 *
 * 프레임마다 textContent 를 직접 쓴다. setState 로 돌리면 60fps 로
 * 리렌더가 걸리는데, 바뀌는 건 이 span 의 글자 하나뿐이다.
 */
export function CountUp({ to, active }) {
  const ref = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    if (!active) {
      el.textContent = '0';
      return undefined;
    }

    if (prefersReducedMotion) {
      el.textContent = String(to);
      return undefined;
    }

    let frame = 0;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / DURATION, 1);
      const eased = 1 - (1 - progress) ** 3; // easeOutCubic
      el.textContent = String(Math.round(to * eased));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [active, to, prefersReducedMotion]);

  return (
    <span ref={ref} className="count-up">
      0
    </span>
  );
}
